import { SendhubApiClient } from '@sendhub/api-client-typescript-axios'
import { INTEGRATIONS_BASE_URL, SENDHUB_BASE_URL } from '../../utils/config'
import { attachSendhubSessionKey } from '../../utils/session-key'
import { attachBearerToken } from '../../utils/token-store'

/**
 * Shared SendHub client, routed through the integrations API's `/proxy/`
 * endpoint (which forwards to SENDHUB_BASE_URL, carrying our headers with it).
 *
 * Built here once rather than per call site so the session-key forwarding that
 * authenticates these calls can't be forgotten by a new caller — see
 * utils/session-key.ts for why the header is needed at all.
 */
export const sendhubApi = (() => {
  const client = new SendhubApiClient(undefined, `${INTEGRATIONS_BASE_URL}/proxy/${SENDHUB_BASE_URL}`)
  attachSendhubSessionKey(client.axios)
  // /proxy/ is covered by the API's global JWT security, so these calls need the
  // access token too — see utils/token-store.ts.
  attachBearerToken(client.axios)
  return client
})()
